
export default (pnrModel) => {
  let destination = 'NA';
  let origin = 'NA';
  const legCollection = pnrModel?.legCollection || [];
  const flightType = pnrModel?.flightItineraryType;

  if (pnrModel?.flightItineraryType === 'ROUNDTRIP' || pnrModel?.flightItineraryType === 'ONEWAY') {
    origin = legCollection?.[0]?.segmentsCollection?.[0]?.departureAirport || 'NA';
    destination = legCollection?.[0]?.segmentsCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
  } else {
    origin = legCollection?.map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentOrigin = segmentCollection?.[0]?.departureAirport || 'NA';
      return segmentOrigin;
    }).join('-');
    destination = legCollection?.map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentDestination = segmentCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
      return segmentDestination;
    }).join('-');
  }

  function getRegionValue(marketType, regionCode) {
    const regionCodeMap = {
      'CAN': 'CAN',
      'USA': 'USA',
    };
    const regionMap = {
      'ASI': 'ASI',
      'ASIA': 'ASI',
      'CANADA': 'CAN',
      'CENTROAMERICA': 'CAM',
      'CENTROAMERICA_CARIBE': 'CAR',
      'DOMESTIC': 'DOM',
      'EUROPA': 'EUR',
      'Frontera': 'FRO',
      'Local': 'LOC',
      'Playa': 'PLA',
      'SUDAMERICA_ASIA': 'SUD',
      'CAN': 'CAN',
      'CAM': 'CAM',
      'CAR': 'CAR',
      'DOM': 'DOM',
      'EUR': 'EUR',
      'FRO': 'FRO',
      'LOC': 'LOC',
      'PLA': 'PLA',
      'SUD': 'SUD',
    };

    if (marketType === 'TRANSBORDER') {
      return regionCodeMap[regionCode] || 'DOM';
    } else {
      return regionMap[marketType] || 'DOM';
    }
  }
  
  const region = getRegionValue(legCollection?.[0]?.legRegion, legCollection?.[0]?.regionKey);
  const isInternationalFlight = legCollection?.some(legs => legs?.marketFlight !== 'DOMESTIC');
  const zone = isInternationalFlight ? 'INT' : 'DOM';
  const tripType = flightType === 'ONEWAY' ? 'OW' : flightType === 'ROUNDTRIP' ? 'RT' : 'MC';
  return {
    'event': 'sr_autoaccept',
    'funnel_name': 'SR',
    'sub_funnel_name': 'SR-involuntary_autoaccept',
    'origin': origin,
    'destination': destination,
    'zone': zone,
    'trip_type': tripType,
    'change_type': 'Involuntary',
    'change_reason': 'IROPS',
    'region': region,
  };
};